import script from "./MenuUI.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuUI.vue?vue&type=script&setup=true&lang=js"

import "./MenuUI.vue?vue&type=style&index=0&id=7e3c284e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e3c284e"]])

export default __exports__